var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M24.79 8.45L17.38.27a.83.83 0 00-.61-.27h-4.95a.82.82 0 00-.61 1.36L18.13 9l-6.92 7.63a.81.81 0 00-.14.88c.14.3.43.49.75.49h4.95c.23 0 .45-.1.6-.27l7.42-8.18a.81.81 0 000-1.1z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M13.79 8.45L6.38.27A.83.83 0 005.77 0H.82a.81.81 0 00-.61 1.36L7.13 9 .2 16.63a.81.81 0 00-.14.88c.14.3.43.49.75.49h4.95c.23 0 .45-.1.6-.27l7.42-8.18a.81.81 0 000-1.1z",
    fill: "#fff"
  })));
}
export default SvgArrow;